/**
 * Skeleton Component
 * Loading placeholder with shimmer animation
 * Based on shadcn/ui skeleton component
 */

import type { HTMLAttributes } from 'react';
import { cn } from '@/shared/utils/cn';

type SkeletonProps = HTMLAttributes<HTMLDivElement>;

/**
 * Skeleton loading placeholder
 *
 * @example
 * ```tsx
 * <Skeleton className="h-12 w-full" />
 * <Skeleton className="h-64 w-64 rounded-full" />
 * <Skeleton className="w-full" style={{ height: '1400px' }} />
 * ```
 */
export const Skeleton = ({ className, ...props }: SkeletonProps) => {
  return (
    <div
      className={cn(
        'animate-pulse rounded-md bg-gray-200',
        className
      )}
      {...props}
    />
  );
};

